<template>
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
  >
    <path d="M0 5.00001C-1.81059e-08 4.58579 0.335786 4.25001 0.75 4.25001L9.53698 4.25L6.24991 1.30894C5.94122 1.03274 5.91488 0.5586 6.19107 0.249911C6.46727 -0.0587779 6.94141 -0.0851194 7.2501 0.191076L12.0001 4.44107C12.1591 4.58335 12.25 4.78663 12.25 5C12.25 5.21338 12.1591 5.41666 12.0001 5.55894L7.2501 9.80894C6.94141 10.0851 6.46727 10.0588 6.19107 9.7501C5.91488 9.44142 5.94122 8.96727 6.24991 8.69108L9.53698 5.75L0.75 5.75001C0.335786 5.75001 1.81059e-08 5.41422 0 5.00001Z" />
  </svg>
</template>
